import React from "react"
import { useEffect, useState } from "react"
import { AppCheckStatusAlertView } from "react-ui-components/components/AppCheckStatusAlertView"
import { APP_CHECK_STATUS_EVENT, AppCheckStatusDetail, isLocalHost } from "../../firebaseAppCheckStatus"
import { useNamespacedTranslation } from "../../hooks/useNamespacedTranslation"

export const AppCheckStatusAlert: React.FC = () => {
  const [message, setMessage] = useState<string | null>(null)
  const { t } = useNamespacedTranslation(["common"])

  useEffect(() => {
    if (!isLocalHost || typeof window === "undefined") {
      return undefined
    }

    const handler = (event: Event) => {
      const detail = (event as CustomEvent<AppCheckStatusDetail>).detail
      if (!detail || detail.status !== "error") {
        return
      }
      setMessage(
        detail.code
          ? `${detail.code}: ${detail.message}`
          : detail.message || t("App Check failed to acquire a token."),
      )
    }

    window.addEventListener(APP_CHECK_STATUS_EVENT, handler as EventListener)
    return () => window.removeEventListener(APP_CHECK_STATUS_EVENT, handler as EventListener)
  }, [t])

  return (
    <AppCheckStatusAlertView
      dismissLabel={t("Dismiss App Check warning")}
      message={message}
      onDismiss={() => setMessage(null)}
      title={t("App Check warning")}
    />
  )
}
